import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import hubManagementService from "services/hubManagementService";

export const useHubList = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  const { params, key, enabled } = payload;

  return useQuery(
    [key || "hubList", params?.page],
    () => hubManagementService.listHub(payload),
    {
      enabled: enabled || false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message || t("message.get_hub_list_error"),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return {
          items: data.items || [],
          params: params,
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};

// Create Hub
export const useCreateHub = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  return useMutation(hubManagementService.createHub, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.create", {
          target: t("hub"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.create", {
              target: t("hub"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Detail Hub
export const useDetailHub = (payload, onSuccess, onError) => {
  const { t, i18n } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  return useQuery(
    ["hub", "detail", payload.hubId],
    () => hubManagementService.detailHub(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.detail", {
                target: t("hub"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return data;
      },
    }
  );
};

export const useUpdateHub = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  return useMutation(hubManagementService.updateHub, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.update", {
          target: t("hub"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.update", {
              target: t("hub"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};
